"use client"

import {createContext, useContext, useEffect, useMemo, useState} from 'react';


export const ScreenSizeContext = createContext(null);

export const ScreenSizeContextProvider = ({children}) => {

  const [screen_size, set_screen_size] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      set_screen_size({
        width: window?.innerWidth,
        height: window?.innerHeight
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const safe_window = typeof window !== 'undefined' ? window: null;

  const values = useMemo(() => ({
    screen_size,
    set_screen_size,
    width: screen_size?.width,
    height: screen_size?.height,
  }), [screen_size, safe_window]);

  return (
    <ScreenSizeContext.Provider value={{...values}}>
      {children}
    </ScreenSizeContext.Provider>
  );
};

export const useScreenSizeContext = () => useContext(ScreenSizeContext)